export default "__VITE_ASSET__Bg$NQw0f__"